var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dividing-line thin mt-0 mb-5",class:{ 'is-hidden-mobile': _vm.isHiddenMobile }})}
var staticRenderFns = []

export { render, staticRenderFns }